import { render, staticRenderFns } from "./ImageDynamicLinkReport.vue?vue&type=template&id=3c72ec9d&scoped=true&"
import script from "./ImageDynamicLinkReport.vue?vue&type=script&lang=ts&"
export * from "./ImageDynamicLinkReport.vue?vue&type=script&lang=ts&"
import style0 from "./ImageDynamicLinkReport.vue?vue&type=style&index=0&id=3c72ec9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c72ec9d",
  null
  
)

export default component.exports